/* Dagobert Industrie : commande rapide, description repliable, vidéo YouTube légère, barre livraison offerte. */
(function () {
  if (window.DgbSections) return;
  window.DgbSections = true;

  const num = (s) => { const m = String(s).match(/(\d+(?:[.,]\d+)?)/); return m ? parseFloat(m[1].replace(',', '.')) : null; };
  const cmp = (a, b) => { const x = num(a), y = num(b); return x !== null && y !== null && x !== y ? x - y : String(a).localeCompare(String(b), 'fr'); };
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(cents / 100);

  /* ---------- Commande rapide ---------- */
  class DgbQuickOrder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tbody = this.querySelector('tbody');
      this.rows = Array.from(this.querySelectorAll('tr[data-id]'));
      this.btn = this.querySelector('[data-submit]');
      this.summary = this.querySelector('[data-summary]');
      this.msg = this.querySelector('[data-message]');
      const gi = parseInt(this.dataset.groupIndex, 10);
      const opts = (r) => { try { return JSON.parse(r.dataset.options || '[]'); } catch (e) { return []; } };

      this.rows.sort((ra, rb) => {
        const A = opts(ra), B = opts(rb);
        const order = gi >= 0 ? [gi].concat(A.map((_, k) => k).filter((k) => k !== gi)) : A.map((_, k) => k);
        for (const k of order) { const c = cmp(A[k], B[k]); if (c) return c; }
        return 0;
      }).forEach((r) => this.tbody.appendChild(r));

      const tabs = this.querySelector('[data-tabs]');
      if (tabs && gi >= 0) {
        const btns = Array.from(tabs.querySelectorAll('button[data-value]')).filter((b) => b.dataset.value);
        btns.sort((a, b) => cmp(a.dataset.value, b.dataset.value)).forEach((b) => tabs.appendChild(b));
        tabs.hidden = btns.length < 2;
        tabs.addEventListener('click', (e) => {
          const b = e.target.closest('button[data-value]');
          if (!b) return;
          tabs.querySelectorAll('button[data-value]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
          this.rows.forEach((r) => { r.hidden = !!b.dataset.value && opts(r)[gi] !== b.dataset.value; });
        });
      }

      this.addEventListener('input', () => this.refresh());
      if (this.btn) this.btn.addEventListener('click', () => this.submit());
      this.markCurrent(new URLSearchParams(location.search).get('variant') || this.dataset.current);
      document.addEventListener('change', (e) => {
        if (e.target.closest && e.target.closest('variant-selects')) {
          setTimeout(() => this.markCurrent(new URLSearchParams(location.search).get('variant')), 500);
        }
      });
      this.refresh();
    }

    markCurrent(id) {
      if (!id) return;
      this.rows.forEach((r) => r.classList.toggle('is-current', r.dataset.id === String(id)));
    }

    selected() {
      return this.rows
        .map((r) => ({ r, q: parseInt(r.querySelector('input').value, 10) || 0 }))
        .filter((x) => x.q > 0);
    }

    refresh() {
      const sel = this.selected();
      let total = 0, units = 0;
      sel.forEach((x) => { total += parseInt(x.r.dataset.price, 10) * x.q; units += x.q; });
      this.rows.forEach((r) => r.classList.toggle('has-qty', (parseInt(r.querySelector('input').value, 10) || 0) > 0));
      if (this.btn) this.btn.disabled = !sel.length;
      if (this.summary) {
        this.summary.textContent = sel.length
          ? sel.length + ' référence' + (sel.length > 1 ? 's' : '') + ', ' + units + ' article' + (units > 1 ? 's' : '') + ' : ' + money(total)
          : this.dataset.empty;
      }
    }

    async submit() {
      const sel = this.selected();
      if (!sel.length) return;
      this.btn.disabled = true;
      this.btn.setAttribute('aria-busy', 'true');
      try {
        const url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: sel.map((x) => ({ id: parseInt(x.r.dataset.id, 10), quantity: x.q })),
            sections: 'cart-icon-bubble'
          })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);
        if (data.sections && data.sections['cart-icon-bubble']) {
          const bubble = document.getElementById('cart-icon-bubble');
          const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && html) bubble.innerHTML = html.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dgb-quick-order' });
        }
        this.rows.forEach((r) => { const i = r.querySelector('input'); if (!i.disabled) i.value = 0; });
        this.showMessage(this.dataset.success, true);
      } catch (err) {
        this.showMessage(err.message || this.dataset.error, false);
      }
      this.btn.removeAttribute('aria-busy');
      this.refresh();
    }

    showMessage(text, ok) {
      if (!this.msg) return;
      this.msg.hidden = false;
      this.msg.querySelector('[data-text]').textContent = text;
      const link = this.msg.querySelector('a');
      if (link) link.hidden = !ok;
    }
  }
  if (!customElements.get('dgb-quick-order')) customElements.define('dgb-quick-order', DgbQuickOrder);


  /* ---------- Barre livraison offerte ---------- */
  class DgbFreeShipping extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      try { this.prices = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { this.prices = {}; }
      this.cartTotal = null;
      this.update = this.update.bind(this);
      const later = () => setTimeout(this.update, 60);
      document.addEventListener('change', later);
      document.addEventListener('input', (e) => { if (e.target.name === 'quantity') this.update(); });
      document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('.quantity__button')) later(); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.fetchCart());
        if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, later);
      }
      this.fetchCart();
    }
    async fetchCart() {
      try {
        const res = await fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        this.cartTotal = cart.total_price || 0;
      } catch (e) { this.cartTotal = 0; }
      this.update();
    }
    currentLine() {
      const scope = this.closest('product-info') || document;
      const idInput = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const qtyInput = scope.querySelector('input[name="quantity"]');
      const price = idInput ? this.prices[idInput.value] : null;
      const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      return price != null ? price * qty : 0;
    }
    update() {
      if (!this.threshold) return;
      const text = this.querySelector('[data-text]');
      const fill = this.querySelector('[data-fill]');
      let msg = this.dataset.textStart, pct = 0, done = false;
      if (this.cartTotal > 0) {
        const left = this.threshold - this.cartTotal;
        done = left <= 0;
        pct = Math.min(100, (this.cartTotal / this.threshold) * 100);
        msg = done ? this.dataset.textDone : this.dataset.textLeft.replace('[montant]', money(left));
      } else {
        const line = this.currentLine();
        pct = Math.min(100, (line / this.threshold) * 100);
        if (line >= this.threshold) { done = true; msg = this.dataset.textItem; }
      }
      if (text) text.textContent = msg;
      if (fill) fill.style.width = pct + '%';
      this.classList.toggle('is-done', done);
    }
  }
  if (!customElements.get('dgb-free-shipping')) customElements.define('dgb-free-shipping', DgbFreeShipping);

  /* ---------- Description repliable ---------- */
  function initDescriptions(scope) {
    scope.querySelectorAll('[data-dgb-clamp]').forEach((box) => {
      if (box._ready) return;
      box._ready = true;
      if (box.hasAttribute('data-has-video')) {
        const re = /https?:\/\/(www\.)?(youtube\.com|youtu\.be)\/\S+/gi;
        const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach((n) => {
          if (!re.test(n.textContent)) return;
          re.lastIndex = 0;
          n.textContent = n.textContent.replace(re, '').trim();
          const parent = n.parentElement;
          if (parent && parent !== box && !parent.textContent.trim() && !parent.querySelector('img')) parent.remove();
        });
      }
      const btn = document.querySelector('[aria-controls="' + box.id + '"]');
      if (box.scrollHeight <= box.clientHeight + 40) {
        box.classList.add('is-open');
        if (btn) btn.hidden = true;
      }
    });
  }

  document.addEventListener('click', (e) => {
    const more = e.target.closest('[data-dgb-more]');
    if (more) {
      const box = document.getElementById(more.getAttribute('aria-controls'));
      if (!box) return;
      const open = box.classList.toggle('is-open');
      more.setAttribute('aria-expanded', String(open));
      more.textContent = open ? more.dataset.less : more.dataset.more;
      if (!open) box.scrollIntoView({ block: 'start' });
      return;
    }
    const video = e.target.closest('[data-dgb-video]');
    if (video) {
      const title = (video.dataset.title || 'Vidéo').replace(/"/g, '&quot;');
      video.parentElement.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(video.dataset.dgbVideo) +
        '?autoplay=1&rel=0" title="' + title + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    }
  });

  const boot = (scope) => initDescriptions(scope || document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
